import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { NavLink } from "react-router-dom";

import { fonts } from "../../../styles/variables";

const StyledTab = styled(NavLink)`
  flex: 1 1 auto;
  border-bottom: transparent solid 2px;
  font-family: ${fonts.fontConceptRegular};
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-transform: capitalize;

  &.active {
    border-bottom: black solid 2px;
    font-family: ${fonts.fontInterstateUltraBlack};
    letter-spacing: 1.4px;
    text-transform: uppercase;
  }

  &::after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 2px;
    background: black;
    transform: scaleX(0);
    transition: transform 250ms ease-in-out;
  }

  /* slide from right */
  &:first-child::after {
    transform-origin: 100% 50%;
  }

  /* slide from left */
  & + a:last-child::after {
    transform-origin: 0 50%;
  }
`;

const Tab = ({ children, to, exact = true }) => (
  <StyledTab to={to} exact={exact}>
    <span>{children}</span>
  </StyledTab>
);

Tab.propTypes = {
  to: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]).isRequired,
  children: PropTypes.string.isRequired,
  exact: PropTypes.bool,
};

export default Tab;
